import React, { useState } from 'react';
import axiosInstance from "../../utils/axios";
import { useNavigate } from 'react-router-dom';
import './RegisterUserPage.css';

function RegisterUserPage() {
    const [formData, setFormData] = useState({
        username: '',
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        confirmPassword: '',
        role: ''
    });
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [passwordMatchError, setPasswordMatchError] = useState('');

    const handleChange = (e) => {
        const newFormData = {
            ...formData,
            [e.target.name]: e.target.value
        };
        setFormData(newFormData);

        if (errorMessage) setErrorMessage('');
        if (successMessage) setSuccessMessage('');

        if (e.target.name === 'password' || e.target.name === 'confirmPassword') {
            if (newFormData.confirmPassword && newFormData.password !== newFormData.confirmPassword) {
                setPasswordMatchError('Paroolid ei kattu');
            } else {
                setPasswordMatchError('');
            }
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (formData.password !== formData.confirmPassword) {
            setErrorMessage("Paroolid ei kattu!");
            setPasswordMatchError("Paroolid ei kattu!");
            return;
        }
        
        if (passwordMatchError) {
            return;
        }

        if (formData.password !== formData.password.trim()) {
            setErrorMessage("Parool ei tohi alata ega lõppeda tühikuga!");
            return;
        }

        const { confirmPassword, ...rest } = formData;
        const userData = {
            ...rest,
            username: rest.username.trim(),
            firstName: rest.firstName.trim(),
            lastName: rest.lastName.trim(),
            email: rest.email.trim()
        };

        axiosInstance.post("/api/public/register", userData)
            .then(res => {
                setSuccessMessage("Registreerimine oli edukas! Palun kontrolli oma emaili.");
                setTimeout(() => {
                    navigate('/login');
                }, 5000);
            })
            .catch(err => {
                const msg = err.response?.data?.message || "Kasutajat ei loodud. Kasutajanimi või email võib olla juba kasutuses.";
                setErrorMessage(msg);
        });

    };

    return (
        <div className="create-user-container">
            <div>
                <form onSubmit={handleSubmit} className="create-user-form">
                    <input type="text"
                           name="username"
                           placeholder="Kasutajanimi"
                           value={formData.username}
                           onChange={handleChange}
                           required>
                    </input>
                    <input type="text"
                           name="firstName"
                           placeholder="Eesnimi"
                           value={formData.firstName}
                           onChange={handleChange}
                           required>
                    </input>
                    <input type="text"
                           name="lastName"
                           placeholder="Perekonnanimi"
                           value={formData.lastName}
                           onChange={handleChange}
                           required>
                    </input>
                    <input type="email"
                           name="email"
                           placeholder="Email"
                           value={formData.email}
                           onChange={handleChange}
                           required>
                    </input>
                    <select name="role"
                            value={formData.role}
                            onChange={handleChange}
                            required
                            style={{ padding: '10px', borderRadius: '5px', border: '1px solid #cbd5e1', fontSize: '16px' }}>
                        <option value="">Vali oma roll</option>
                        <option value="ksv!">ksv!</option>
                        <option value="vil!">vil!</option>
                        <option value="külaline">külaline</option>
                        <option value="noorliige">noorliige</option>
                    </select>
                    <input type="password"
                           name="password"
                           placeholder="Parool"
                           minLength={6}
                           value={formData.password}
                           onChange={handleChange}
                           required>
                    </input>
                    <input type="password"
                           name="confirmPassword"
                           placeholder="Sisesta parool uuesti"
                           minLength={6}
                           value={formData.confirmPassword}
                           onChange={handleChange}
                           required
                           className={passwordMatchError ? 'password-error' : ''}>
                    </input>
                    {passwordMatchError && (
                        <p className="password-match-error" style={{ color: '#334155', fontSize: '12px', marginTop: '-10px', marginBottom: '10px' }}>
                            {passwordMatchError}
                        </p>
                    )}
                    <button type="submit">
                        Registeeri
                    </button>
                </form>
                {successMessage && (
                    <p className="success-message" style={{ color: '#334155', marginTop: '10px', textAlign: 'center', padding: '10px', backgroundColor: '#ffffff', borderRadius: '5px' }}>
                        {successMessage}
                    </p>
                )}
                {errorMessage && (
                    <p className="error-message" style={{ color: '#334155', marginTop: '10px', textAlign: 'center' }}>
                        {errorMessage}
                    </p>
                )}
                <div className="login-link" 
                style={{ textAlign: 'center', marginTop: '15px', color: '#334155', fontSize: '14px'}}>
                    Konto on juba olemas?
                    <a href="/login" style={{ color: '#334155', textDecoration: 'none', fontWeight: '600'}}>
                    Logi sisse siit
                    </a>
                </div>
            </div>
        </div>
    );
}

export default RegisterUserPage;